<template>
  <div class="v-input v-text-field v-input--is-label-active read-only-field">
    <div class="v-input__control">
      <label aria-hidden="true" class="v-label v-label--active" style="left: 0px; right: auto; position: absolute;">{{ label }}</label>
      <input :aria-label="label" type="text" :value="value" class="font-weight-medium" readonly>
    </div>
    <div class="v-input__append-outer">
      <slot name="append-outer" />
    </div>
  </div>
</template>

<script>
  export default {
    props: ['value', 'label']
  }
</script>

<style scoped>
  .read-only-field {
    padding-bottom: 12px;
  }
  .v-input__control {
    position: relative;
  }
</style>
